/* 계산 엔진(Compute Engine)을 만드는 곳. 식 입구(expr.ts)와 기호 번역(symbols.ts)이 같은 선언으로 식을 읽는다 */
import { ComputeEngine } from '@cortex-js/compute-engine';

/** 값이 필요한 기호가 아닌 것: 변수 x, y 와 문항이 함수 이름으로 쓰는 f, g, h */
export const NOT_SYMBOLS: readonly string[] = ['x', 'y', 'f', 'g', 'h'];

// 선언하지 않으면 m(x-1) 을 함수 호출로 읽는다. e, f, g, h, i, x, y 는 상수, 함수 이름, 변수라 뺀다
const LATIN_NUMBERS = 'abcdjklmnopqrstuvwz';
// 선언하지 않으면 \alpha(x-1) 을 함수 호출로 읽고 \gamma 를 오일러 상수로 읽는다. \pi 는 mathcore 가 읽으므로 뺀다. 뒤쪽 다섯은 변형 글리프를 엔진이 부르는 이름이다
const GREEK_NUMBERS = [
  'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'rho', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega',
  'epsilonSymbol', 'thetaSymbol', 'piSymbol', 'rhoSymbol', 'finalSigma',
];

/** 새 엔진. 이름의 종류를 처음 쓰인 꼴로 굳히므로 서로 상관없는 식 묶음은 엔진을 따로 쓴다 */
export function newEngine(): ComputeEngine {
  const ce = new ComputeEngine();
  for (const letter of LATIN_NUMBERS) ce.declare(letter, 'number');
  for (const fn of 'fgh') ce.declare(fn, 'function');
  for (const name of GREEK_NUMBERS) ce.declare(name, 'number');
  return ce;
}

// 이름 풀이용 엔진 하나. 입력이 기호 하나뿐이라 앞 식에 오염될 일이 적다
const namer = newEngine();

/** 이름 표기(alpha, \alpha, α, a_1, a_{1}, K)를 엔진이 부르는 정규 이름으로. 기호 하나로 읽히지 않거나 상수로 읽히면 null.
 * known 은 엔진이 이미 낸 정규 이름(a_12, epsilonSymbol 처럼 표기로는 다시 읽히지 않는 것)이라 그대로 받는다 */
export function canonicalName(raw: string, known: readonly string[] = []): string | null {
  const text = String(raw ?? '').trim();
  if (!text) return null;
  if (known.includes(text)) return text;
  const candidates = text.startsWith('\\') ? [text] : [text, `\\${text}`];
  for (const candidate of candidates) {
    try {
      const e = namer.parse(candidate);
      if (e.unknowns.length === 1 && e.json === e.unknowns[0]) return e.unknowns[0];
    } catch {
      // 다음 후보로
    }
  }
  return null;
}

/** 정규 이름의 LaTeX 표기(프롬프트에 문항의 표기로 보여 주려는 것) */
export function latexOf(name: string): string {
  try { return namer.box(name).latex; } catch { return name; }
}
